import React, { Component } from 'react';
import './ChartModele.css';
import { SpinnerChargement } from '../Loader/SpinnerChargement';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

export class ChartModele extends Component {

    _creationContent = () => {
        return <Stack className="BlocChart">
            <div className="TitreBlocChart">{this.props.titre}</div>
            {this.props.afficheMessagePasDeDonnees ? <span>Aucune données</span> : <canvas id={this.props.idChart} width="200" height="200"></canvas>}
            {this.props.chargementEnCours && <SpinnerChargement />}
        </Stack>
    }

    render = () => this._creationContent();

}